import POIStep from "@/components/POI/POIStep/POIStep.vue";
import DateInput from "@/components/Common/DateInput/DateInput.vue";

export default {
  name: "LatestNews",
  components: { POIStep, DateInput },
  props: ["editedItem", "step", "position", "isOwnedBySubPrincipal"],
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js"
  }),
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    }
  }
};
